var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group-material material-input-slot-wrapper",
      class:
        ((_obj = {}),
        (_obj[_vm.validationClasses] = true),
        (_obj["form-group-material-no-label"] = _vm.noLabel),
        (_obj.disabled = _vm.disabled),
        (_obj["form-group-material-focused"] = _vm.focused),
        _obj),
      attrs: { id: _vm.id },
    },
    [
      _vm._t(
        "default",
        function () {
          return [
            _vm.type === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localValue,
                      expression: "localValue",
                    },
                  ],
                  ref: "profileDetailsEmailInput",
                  staticClass: "material-input form no-event",
                  class: _vm.inputClasses,
                  attrs: {
                    id: _vm.id ? _vm.id : _vm.labelValue,
                    "data-lpignore": _vm.autoCompleteValue ? "true" : null,
                    required: "",
                    readonly: _vm.readOnly,
                    disabled: _vm.disabled,
                    autocomplete: _vm.autoCompleteValue,
                    placeholder: _vm.placeholder,
                    type: "checkbox",
                  },
                  domProps: {
                    value: _vm.localValue,
                    checked: Array.isArray(_vm.localValue)
                      ? _vm._i(_vm.localValue, _vm.localValue) > -1
                      : _vm.localValue,
                  },
                  on: {
                    blur: _vm.handleBlur,
                    focus: _vm.handleFocus,
                    change: [
                      function ($event) {
                        var $$a = _vm.localValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = _vm.localValue,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.localValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.localValue = $$c
                        }
                      },
                      _vm.handleChange,
                    ],
                    input: _vm.handleInput,
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEnter.apply(null, arguments)
                    },
                  },
                })
              : _vm.type === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localValue,
                      expression: "localValue",
                    },
                  ],
                  ref: "profileDetailsEmailInput",
                  staticClass: "material-input form no-event",
                  class: _vm.inputClasses,
                  attrs: {
                    id: _vm.id ? _vm.id : _vm.labelValue,
                    "data-lpignore": _vm.autoCompleteValue ? "true" : null,
                    required: "",
                    readonly: _vm.readOnly,
                    disabled: _vm.disabled,
                    autocomplete: _vm.autoCompleteValue,
                    placeholder: _vm.placeholder,
                    type: "radio",
                  },
                  domProps: {
                    value: _vm.localValue,
                    checked: _vm._q(_vm.localValue, _vm.localValue),
                  },
                  on: {
                    blur: _vm.handleBlur,
                    focus: _vm.handleFocus,
                    change: [
                      function ($event) {
                        _vm.localValue = _vm.localValue
                      },
                      _vm.handleChange,
                    ],
                    input: _vm.handleInput,
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEnter.apply(null, arguments)
                    },
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localValue,
                      expression: "localValue",
                    },
                  ],
                  ref: "profileDetailsEmailInput",
                  staticClass: "material-input form no-event",
                  class: _vm.inputClasses,
                  attrs: {
                    id: _vm.id ? _vm.id : _vm.labelValue,
                    "data-lpignore": _vm.autoCompleteValue ? "true" : null,
                    required: "",
                    readonly: _vm.readOnly,
                    disabled: _vm.disabled,
                    autocomplete: _vm.autoCompleteValue,
                    placeholder: _vm.placeholder,
                    type: _vm.type,
                  },
                  domProps: { value: _vm.localValue, value: _vm.localValue },
                  on: {
                    blur: _vm.handleBlur,
                    focus: _vm.handleFocus,
                    change: _vm.handleChange,
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.localValue = $event.target.value
                      },
                      _vm.handleInput,
                    ],
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEnter.apply(null, arguments)
                    },
                  },
                }),
          ]
        },
        null,
        Object.assign({}, _vm.validation, {
          isSoft: _vm.isSoft,
          inputClasses: _vm.inputClasses,
        })
      ),
      _vm._v(" "),
      _vm._t("input-icon"),
      _vm._v(" "),
      _vm._t("input-icon-client"),
      _vm._v(" "),
      _vm.validation.$pending
        ? _c("span", { staticClass: "loading-feedback" }, [
            _c(
              "div",
              { staticClass: "loading-icon" },
              [_c("material-input-validation-loader")],
              1
            ),
          ])
        : _vm.validation.$error
        ? _c(
            "span",
            { staticClass: "invalid-feedback", class: { soft: _vm.isSoft } },
            [
              _c(
                "div",
                { staticClass: "invalid-icon", class: { soft: _vm.isSoft } },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: {
                          title: _vm.message,
                          disabled: !_vm.showTooltipMessage,
                        },
                        expression:
                          "{\n          title: message,\n          disabled: !showTooltipMessage\n        }",
                      },
                    ],
                    staticClass: "fa fa-exclamation-circle",
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.message && !_vm.showTooltipMessage
                ? _c(
                    "ul",
                    {
                      staticClass: "filled",
                      staticStyle: {
                        "list-style-type": "none",
                        width: "100%",
                        padding: "0",
                      },
                      attrs: { id: "parsley-id-9" },
                    },
                    [
                      _c("li", { staticClass: "parsley-required" }, [
                        _vm._v(_vm._s(_vm.message)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "bar" }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "title mb-2 mb-lg-0",
              class: _vm.labelClasses,
              attrs: { for: _vm.id ? _vm.id : _vm.labelValue },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
              _vm.requiredIndicator ? _c("input-required-indicator") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }